import { doc, setDoc, getDoc, updateDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

/**
 * Update user settings in Firestore PsapUsers collection
 * @param {string} userId - User's UID
 * @param {Object} settings - Settings object to save
 * @returns {boolean} - Success status
 */
export const updateUserSettings = async (userId, settings) => {
  try {
    const userRef = doc(db, 'PsapUsers', userId);
    
    // Get current user data first to avoid overwriting other fields
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      console.error('User document does not exist in PsapUsers collection');
      return false;
    }
    
    // Update only the settings fields, keeping the rest of the user data intact
    const settingsToUpdate = {
      settings: {
        notificationSound: settings.notificationSound,
        showAcknowledgmentDialog: settings.showAcknowledgmentDialog,
        updatedAt: serverTimestamp()
      }
    };
    
    await updateDoc(userRef, settingsToUpdate);
    return true;
  } catch (error) {
    console.error('Error updating user settings:', error);
    return false;
  }
};

/**
 * Get user settings from PsapUsers document
 * @param {string} userId - User's UID
 * @returns {Object} - User settings or default settings if not found
 */
export const getUserSettings = async (userId) => {
  try {
    const userRef = doc(db, 'PsapUsers', userId);
    const userDoc = await getDoc(userRef);
    
    if (userDoc.exists() && userDoc.data().settings) {
      return userDoc.data().settings;
    } else {
      // Return default settings if none exist
      return {
        notificationSound: 'seatbelttone.wav',
        showAcknowledgmentDialog: true
      };
    }
  } catch (error) {
    console.error('Error getting user settings:', error);
    return {
      notificationSound: 'seatbelttone.wav',
      showAcknowledgmentDialog: true
    };
  }
};

/**
 * Create default user settings in PsapUsers document
 * @param {string} userId - User's UID
 * @returns {boolean} - Success status
 */
export const createDefaultUserSettings = async (userId) => {
  try {
    const userRef = doc(db, 'PsapUsers', userId);
    const userDoc = await getDoc(userRef);
    
    if (!userDoc.exists()) {
      console.error('User document does not exist in PsapUsers collection');
      return false;
    }
    
    const defaultSettings = {
      settings: {
        notificationSound: 'seatbelttone.wav',
        showAcknowledgmentDialog: true,
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      }
    };
    
    await updateDoc(userRef, defaultSettings);
    return true;
  } catch (error) {
    console.error('Error creating default user settings:', error);
    return false;
  }
};
